import { useState } from 'react'
import { Modal, Stack, Text, TextInput, Button, Group } from '@mantine/core'
import { useMutation, useQuery } from '@apollo/client/react'
import InviteByEmail from '../graphql/queries/InviteByEmail'
import Room from '../graphql/queries/Room'
import { emailIsValid } from '../util/validation'

export default function ShareModal({ opened, onClose, roomId, ...rest }) {
    const [inviteEmail, setInviteEmail] = useState('')
    const [inviteMessage, setInviteMessage] = useState('')
    const [inviteError, setInviteError] = useState('')

    const { data: roomData } = useQuery(Room, { variables: { roomId }, skip: !roomId })
    const room = roomData?.room

    const [inviteByEmailMutation, { loading }] = useMutation(InviteByEmail)

    async function sendEmailInvite() {
        setInviteMessage('')
        setInviteError('')
        try {
            await inviteByEmailMutation({
                variables: { roomId, email: inviteEmail },
                refetchQueries: [{ query: Room, variables: { roomId } }]
            })
            setInviteMessage('Invitation sent!')
            setInviteEmail('')
        } catch (error) {
            setInviteError(error.message)
        }
    }

    function handleClose() {
        setInviteEmail('')
        setInviteMessage('')
        setInviteError('')
        onClose()
    }

    return (
        <Modal
            opened={opened}
            onClose={handleClose}
            title={room ? `Invite to "${room.name}"` : 'Share Room'}
            centered
            size="sm"
            {...rest}
            styles={{
                title: {
                    fontSize: '1.125rem',
                    fontWeight: 700,
                    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
                }
            }}
        >
            <Stack gap="sm" mt="xs">
                <Text size="sm" c="dimmed">
                    Enter the email address of someone you'd like to invite to this room.
                </Text>
                <Group gap="xs" align="flex-end">
                    <TextInput
                        value={inviteEmail}
                        onChange={(e) => setInviteEmail(e.target.value)}
                        placeholder="Email address"
                        size="sm"
                        style={{ flex: 1 }}
                        error={inviteError}
                        onKeyDown={(e) => { if (e.key === 'Enter' && emailIsValid(inviteEmail)) sendEmailInvite() }}
                    />
                    <Button
                        onClick={sendEmailInvite}
                        disabled={loading || !emailIsValid(inviteEmail)}
                        size="sm"
                        loading={loading}
                    >
                        Send Invite
                    </Button>
                </Group>
                {inviteMessage && (
                    <Text size="sm" c="green">{inviteMessage}</Text>
                )}
            </Stack>
        </Modal>
    )
}

